import { Theme } from '@mui/material';
import { CommonComponents } from '../types';

export function getMuiCalendarOrClockPicker(theme: Theme): CommonComponents {
  return {
    styleOverrides: {
      root: {
        boxShadow:
          '0px 2px 5px rgba(31, 34, 38, 0.1), 0px 3px 15px rgba(31, 34, 38, 0.1)',
        borderRadius: theme.shape.borderRadiusXl,
      },
    },
  };
}
